import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { ReactComponent as Settings } from "../../../assets/settings.svg";
import { ReactComponent as ProjectIcon } from "../../../assets/projects-icon.svg";
import { ReactComponent as SetupIcon } from "../../../assets/setup-icon.svg";
import { ReactComponent as DashboardIcon } from "../../../assets/dashboard.svg";
// import { ReactComponent as IMS } from "../../../assets/ims.svg";
// import UseGetUserRole from "../../../components/useGetUserRole";
import axios from "axios";
import { message } from "antd";
import { baseURL } from "../../../globalUtils/axiosConfig";

const useSidebar = () => {
  const { user } = useSelector((state) => state.authReducer);
  const [data, setData] = useState();
  // const [isSuperAdmin] = UseGetUserRole();
  const [showSettings, setShowSettings] = useState(true);
  const [attachmentBlobUrl, setAttachmentBlobUrl] = useState(null);

  useEffect(() => {
    setData(user);

    // Fetch attachment and create blob URL when user changes
    if (user?.attachments?.[0]?.path) {
      fetchAttachmentAndCreateBlobUrl(user.attachments[0]);
    }
  }, [user]);

  // Function to fetch attachment and create blob URL
  const fetchAttachmentAndCreateBlobUrl = async (attachment) => {
    try {
      // Create full URL for the attachment using the specific endpoint
      const attachmentUrl = `${baseURL}/attachments/${attachment.id}`;

      // Check if the combined name is too long and should be split
      const isNameTooLong = (firstName, lastName) => {
        return (firstName + " " + lastName).length > 15;
      };

      // Fetch the attachment
      const response = await axios({
        url: attachmentUrl,
        method: 'GET',
        responseType: 'blob',
      });

      // Get the mime type
      const mimeType = response.headers['content-type'] || 'application/octet-stream';

      // Create blob and URL
      const blob = new Blob([response.data], { type: mimeType });
      const blobUrl = window.URL.createObjectURL(blob);

      // Set the blob URL in state
      setAttachmentBlobUrl(blobUrl);
    } catch (error) {
      console.error('Error fetching attachment:', error);
      message.error(`Failed to load attachment: ${error.response?.data?.message || error.message}`);
    }
  };

  const hanldeRoleLength = (role) =>
    role.length > 20 ? `${role.substring(0, 18) + " ..."}` : role;

  // Check if the combined name is too long and should be split
  const isNameTooLong = (firstName, lastName) => {
    return (firstName + " " + lastName).length > 15;
  };

  const menuItemsData = [
    {
      key: "1",
      src: attachmentBlobUrl || null,
      SvgImg: false,
      alt: "",
      firstName: data?.firstName || "",
      lastName: data?.lastName || "",
      isNameTooLong: isNameTooLong(data?.firstName || "", data?.lastName || ""),
      role: hanldeRoleLength(data?.jobTitle || ""),
      link: "/profile",
      hasSubItems: false,
      permission: true,
      hasPermission: true,
    },
    {
      key: "2",
      SvgImg: DashboardIcon,
      alt: "Dashboard Icon",
      name: "Dashboard",
      link: "/dashboard",
      hasSubItems: false,
      hasPermission: true,
    },
    {
      key: "3",
      SvgImg: ProjectIcon,
      alt: "Project Icon",
      name: "Labs Stock Management",
      link: "/labs-stock-management",
      hasSubItems: true,
      hasPermission: true,
      subItems: [
        {
          key: "lab-control",
          SvgImg: Settings,
          alt: "lab-Control",
          name: "lab-Control",
          link: "/labs-stock-management/lab",
          hasSubItems: false,
          hasPermission: true,
        },
      ],
    },
    {
      key: "4",
      SvgImg: SetupIcon,
      alt: "Labs Setup Icon",
      name: "Labs Setup",
      link: "/labs-setup",
      hasSubItems: false,
      hasPermission: user?.permissions?.labs_setup?.view,
    },
    {
      key: "6",
      SvgImg: Settings,
      alt: "settings",
      name: "Settings",
      link: "/settings",
      hasSubItems: true,
      permission: ["super_admin", "admin"],
      hasPermission: showSettings,
      // showSettings: true,
      subItems: [
        {
          key: "users-manager",
          SvgImg: Settings,
          alt: "Users Manager",
          name: "Users Manager",
          link: "/settings/users-manager",
          hasSubItems: false,
          hasPermission: user?.permissions?.user_manager?.view,
        },
        {
          key: "departments",
          SvgImg: Settings,
          alt: "Departments",
          name: "Departments",
          link: "/settings/departments",
          hasSubItems: false,
          hasPermission: user?.permissions?.departments?.view,
        },
        // {
        //   key: "inventory-products",
        //   SvgImg: Settings,
        //   alt: "Inventory Products",
        //   name: "Inventory Products",
        //   link: "/settings/inventory-products",
        //   hasSubItems: false,
        //   hasPermission: user?.permissions?.inventory_products?.view,
        // },
        {
          key: "variance-statuses",
          SvgImg: Settings,
          alt: "Variance Statuses",
          name: "Variance Statuses",
          link: "/settings/variance-statuses",
          hasSubItems: false,
          hasPermission: user?.permissions?.variance_statuses?.view,
        },
        {
          key: "lab-statuses",
          SvgImg: Settings,
          alt: "Lab Statuses",
          name: "Lab Statuses",
          link: "/settings/lab-statuses",
          hasSubItems: false,
          hasPermission: user?.permissions?.lab_statuses?.view,
        },
      ],
    },
  ];

  return [menuItemsData];
};

export default useSidebar;
